export default __webpack_public_path__ + "static/media/boitf1.c34cfdd7.png";